export class TagsService {
    constructor() {
        this.tags = [];
    }
    add(tag) {
        if (!this.tags.some(t => t.label == tag.label)) {
            this.tags = this.tags.concat(tag);
        }
    }
    changeBackground(tag) {
        this.tags = this.tags.map(t => t.id === tag.props.id ? ({ ...t, background: tag.props.background }) : t);
    }
}
